import { useQuery } from "react-query";
import { getJSON } from "../api/http";
import { endpoints } from "../api/endpoints";

export interface IStbDevice {
    id: string;
    iptv_program: string;
    mac: string;
    serialnumber: string;
    ipaddr_string: string;
    description: string;
    creationdate: string;
    activedate: string;
    model: string;
    status_desc: string;
}

export interface IStbData {
    list: IStbDevice[];
    total: number;
}

export const restructureStbData = (stbData: IStbData) =>
    stbData
        ? stbData.list.map(
            ({ status_desc, ipaddr_string, iptv_program, model, serialnumber, activedate, creationdate, mac, description, id }) => ({
                serialNumber: serialnumber,
                creationDate: creationdate,
                activeDate: activedate,
                macAddress: mac,
                ipAddress: ipaddr_string,
                iptvProgram: iptv_program,
                status: status_desc,
                model,
                description,
                id,
            })
        )
        : [];

const getStbList = async () => getJSON(endpoints.devices.stb);

export const useStbList = () => {
    const { data, isLoading, error } = useQuery(
        "stbList",
        getStbList,
        {
            staleTime: Infinity,
        }
    );

    return {
        isLoading,
        data: restructureStbData(data?.data),
        error,
    };
};
